// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67cdd18a","239":"69b58bf7","455":"b4cb097c"}[chunkId] + ".chunk.js";
};